import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_left_nav = _resolveComponent("app-left-nav")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_app_top_nav = _resolveComponent("app-top-nav")!
  const _component_OpportunitiesList = _resolveComponent("OpportunitiesList")!
  const _component_app_main_layout = _resolveComponent("app-main-layout")!

  return (_openBlock(), _createBlock(_component_app_main_layout, null, {
    left: _withCtx(() => [
      _createVNode(_component_app_left_nav)
    ]),
    top: _withCtx(() => [
      _createVNode(_component_app_top_nav, { padded: "" }, {
        left: _withCtx(() => [
          _createVNode(_component_el_page_header, {
            icon: "el-icon-left",
            title: "Opportunities",
            content: _ctx.count !== undefined ? `${_ctx.count} Opportunities` : ''
          }, null, 8, ["content"])
        ]),
        center: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", null, null, -1)
        ]))]),
        right: _withCtx(() => [...(_cache[1] || (_cache[1] = []))]),
        _: 1
      })
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_OpportunitiesList, {
          loading: _ctx.loading,
          opportunities: _ctx.opportunities
        }, null, 8, ["loading", "opportunities"])
      ])
    ]),
    _: 1
  }))
}